exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-layout[data-v-4ff48641]  .el-table--mini .el-table__cell{padding:4px 0}.table-layout[data-v-4ff48641]  .el-table--mini .cell{padding-left:5px;padding-right:5px}.table-layout[data-v-4ff48641]  .el-table--mini .el-button{padding:4px 8px;margin-right:5px}.table-layout[data-v-4ff48641]  .el-table--mini .el-button+.el-button{margin-left:0}", ""]);

// exports
